import { CreatedInterfaces } from 'interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'unnamed-lots-cards';

const useGetUnnamedCards = (lotNumber: string) => {
  const path = `v2/cards/unnamed/${lotNumber}`;

  const [{ data, error, loading }] = useGetRequest<CreatedInterfaces<typeof resource>>({ path });

  console.log(data);

  return {
    lotSize: data?.lot_size,
    cardProductId: data?.card_product_id,
    type: data?.type,
    balanceType: data?.balance_type,
    cards: data?.cards,
    isLoading: loading,
    isError: error,
  };
};

export default useGetUnnamedCards;
